import _ from 'lodash'

import { COUNTRIES } from './constants'

/**
 * We can generate distraints only for CZ/SK countries
 * Helper function which returns if we can generate distraints based on entity country
 * @param {string} entityCountry Entity country in ISO2 format
 */
export const canGenerateDistraints = (entityCountry = null) => {
    if (_.isNil(entityCountry) || typeof entityCountry !== 'string') return false

    const country = _.toUpper(entityCountry)

    if (country === COUNTRIES.CZ || country === COUNTRIES.SK) return true

    return false
}
